<div class="cd-modal-backdrop" (click)="close.emit()">
  <div class="cd-modal-wrap">
    <!-- Modal Head -->
    <div class="modal-head">
      <div>
        <div class="eyebrow">DETAIL VIEW</div>
        <h2>Opportunity Details</h2>
      </div>
      <button type="button" class="icon-button" (click)="close.emit()" aria-label="Close modal">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div *ngIf="isLoading" class="empty-state-text">Loading opportunity details…</div>

    <ng-container *ngIf="!isLoading && job">
      <!-- Job Hero -->
      <div class="job-hero">
        <div class="company-logo large-logo" [class.has-img]="job.company_logo_url">
          <img *ngIf="job.company_logo_url" [src]="job.company_logo_url" alt="" />
          <ng-container *ngIf="!job.company_logo_url">{{ job.company_name.charAt(0) }}</ng-container>
        </div>
        <div class="hero-text">
          <h3>{{ job.company_name }}</h3>
          <p>{{ job.role }}</p>
          <!-- Not currently shown — job status pill.
          <span class="status-pill" [ngClass]="job.status === 'Applications Open' ? 'success' : 'warning'">
            {{ job.status }}
          </span>
          -->
        </div>
      </div>

      <!-- Description & Package -->
      <div class="job-info-block">
        <div class="info-row">
          <strong>Job Description:</strong>
          <span>{{ job.description || 'Not provided' }}</span>
        </div>
        <div class="info-row">
          <strong>Package:</strong>
          <span>{{ job.package || 'Not provided' }}</span>
        </div>
        <div class="info-row" *ngIf="job.eligible_programs.length">
          <strong>Eligible Programs:</strong>
          <span>{{ job.eligible_programs.join(', ') }}</span>
        </div>
      </div>

      <!-- Metric Grid -->
      <div class="detail-grid">
        <div class="grid-item">
          <span>Applied Students</span>
          <strong>{{ job.applied_students }}</strong>
        </div>
        <!-- Not currently shown — students cleared and deadline.
        <div class="grid-item">
          <span>Students Cleared</span>
          <strong>{{ job.students_cleared }}</strong>
        </div>
        -->
        <div class="grid-item">
          <span>Location</span>
          <strong>{{ job.location || '—' }}</strong>
        </div>
        <!--
        <div class="grid-item">
          <span>Deadline</span>
          <strong>{{ job.deadline ? (job.deadline | date: 'mediumDate') : '—' }}</strong>
        </div>
        -->
      </div>

      <!-- Applicants Section -->
      <div class="applicants-section">
        <div class="applicants-header">
          <h4>APPLICANTS ({{ job.applicants.length }})</h4>
        </div>

        <div class="applicants-list" *ngIf="job.applicants.length > 0; else noApplicants">
          <div
            *ngFor="let applicant of job.applicants"
            class="applicant-row">
            <div class="applicant-info">
              <strong>{{ applicant.name }}</strong>
              <span class="applicant-sub">
                {{ applicant.department || 'Department N/A' }} • {{ applicant.year_of_passing || 'Year N/A' }}
              </span>
            </div>
            <span
              class="status-pill"
              [ngClass]="applicant.status === 'selected' || applicant.status === 'hired' ? 'success' : applicant.status === 'rejected' ? 'warning' : 'neutral'">
              {{ applicant.status }}
            </span>
          </div>
        </div>

        <ng-template #noApplicants>
          <div class="empty-state-text">No applications yet from your college's students.</div>
        </ng-template>
      </div>
    </ng-container>
  </div>
</div>
